var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.25C5 1.86929 6.11929 0.75 7.5 0.75H17.5C18.8807 0.75 20 1.86929 20 3.25V20.75C20 22.1307 18.8807 23.25 17.5 23.25H7.5C6.11929 23.25 5 22.1307 5 20.75V3.25ZM10 3.25H7.5V20.75H17.5V3.25H15C15 3.94036 14.4404 4.5 13.75 4.5H11.25C10.5596 4.5 10 3.94036 10 3.25ZM12.5 17C13.1904 17 13.75 17.5596 13.75 18.25V18.2625C13.75 18.9529 13.1904 19.5125 12.5 19.5125C11.8096 19.5125 11.25 18.9529 11.25 18.2625V18.25C11.25 17.5596 11.8096 17 12.5 17Z",
    fill: "white",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.84afb32b64b7afbcf8fcb452f2682307.svg";
export { ForwardRef as ReactComponent };